


































import Vue from 'vue';
import { IShoppingCartIndividual } from '@/common/interfaces/cart.interface';
import { ILimitingObject } from '@/common/interfaces/limiting.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import ProductListItem from './ProductListItem.vue';
import { IPreviewBlogPost } from '@/common/interfaces/ringana-blog.interfaces';
import ProductListDisruptor from '@/components/productlist/ProductListDisruptor.vue';

export default Vue.extend({
  name: `ProductList`,
  components: { ProductListDisruptor, ProductListItem },
  props: {
    availableCarts: {
      required: true,
      type: Array as () => IShoppingCartIndividual[],
    },
    disruptors: {
      default: () => [],
      type: Array as () => IPreviewBlogPost[],
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    limiting: {
      required: true,
      type: Object as () => ILimitingObject,
    },
    mode: {
      required: true,
      type: String,
    },
    products: {
      required: true,
      type: Array as () => IProduct[],
    },
    selectedCartId: {
      required: true,
      validator: prop => Number.isInteger(prop) || prop === null,
    },
  },
});
